import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className", "cssModule", "fluid", "tag"];
import React from 'react';
import classNames from 'classnames';
import { mapToCssModules } from './utils';
var defaultProps = {
  tag: 'div'
};
var Container = function Container(props) {
  var className = props.className,
    cssModule = props.cssModule,
    fluid = props.fluid,
    Tag = props.tag,
    attributes = _objectWithoutPropertiesLoose(props, _excluded);
  var containerClass = 'container';
  if (fluid === true) {
    containerClass = 'container-fluid';
  } else if (fluid) {
    containerClass = "container-" + fluid;
  }
  var classes = mapToCssModules(classNames(className, containerClass), cssModule);
  return /*#__PURE__*/React.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
};
Container.defaultProps = defaultProps;
export default Container;